import { render, staticRenderFns } from "./KpiTrafficpersqm.vue?vue&type=template&id=6f24fb8e&"
import script from "./KpiTrafficpersqm.vue?vue&type=script&lang=js&"
export * from "./KpiTrafficpersqm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./KpiTrafficpersqm.vue?vue&type=custom&index=0&blockType=i18n&locale=en-us&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./KpiTrafficpersqm.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports